import { RootState } from '..';
import rootGetters from '../getters';
import { getNestedField } from '../utils';
import { required } from '../validations';

export const getValidity =
  (state: RootState) =>
  <T extends FlattenKeys<ValiditiesState>>(field: T) =>
    getNestedField(state.validity, field);

export const getFormMessage =
  (state: RootState) =>
  <F extends FlattenKeys<ValiditiesState['blur'], 2, 1>>(
    form: F,
  ): Record<keyof DeepType<ValiditiesState['blur'], F>, string> => {
    const {
      validity: { getValidity },
    } = rootGetters(state);
    if (form === 'validity.create') {
      const data = getValidity('forms.validity.create');
      const blur = getValidity('blur.validity.create');
      const messages: Record<
        keyof ValiditiesState['blur']['validity']['create'],
        string
      > = {
        // clientName: '',
        productId: '',
        subProductId: '',
        productFullDescription: '',
        productShortDescription: '',
        barcodeNumber: '',
        sectionId: '',
        sectionDescription: '',
        validity: '',
        exitPackaging: '',
        quantity: '',
        statusName: '',
        statusColor: '',
        observation: '',
        branchCode: '',
        branchName: '',
      };
      messages.productShortDescription =
        blur.productShortDescription && !required(data.productShortDescription)
          ? 'Selecione o produto'
          : '';

      messages.sectionDescription =
        blur.sectionDescription && !required(data.sectionDescription)
          ? 'Selecione a seção'
          : '';

      messages.exitPackaging =
        blur.exitPackaging && !required(data.exitPackaging)
          ? 'Selecione a unidade'
          : '';

      messages.quantity =
        blur.quantity && data.quantity === 0 ? 'Informe a quantidade' : '';

      messages.validity =
        blur.validity && !required(data.validity) ? 'Selecione a validade' : '';

      messages.branchCode =
        blur.branchCode && !required(data.branchCode)
          ? 'Selecione a filial'
          : '';

      return messages as any;
    }

    if (form === 'validity.update') {
      const data = getValidity('forms.validity.update');
      const blur = getValidity('blur.validity.update');
      const messages: Record<
        keyof ValiditiesState['blur']['validity']['update'],
        string
      > = {
        // clientName: '',
        productId: '',
        subProductId: '',
        productFullDescription: '',
        productShortDescription: '',
        barcodeNumber: '',
        sectionId: '',
        sectionDescription: '',
        validity: '',
        exitPackaging: '',
        quantity: '',
        statusName: '',
        statusColor: '',
        observation: '',
        branchCode: '',
        branchName: '',
      };
      messages.productShortDescription =
        blur.productShortDescription && !required(data.productShortDescription)
          ? 'Selecione o produto'
          : '';

      messages.sectionDescription =
        blur.sectionDescription && !required(data.sectionDescription)
          ? 'Selecione a seção'
          : '';

      messages.exitPackaging =
        blur.exitPackaging && !required(data.exitPackaging)
          ? 'Selecione a unidade'
          : '';

      messages.quantity =
        blur.quantity && data.quantity === 0 ? 'Informe a quantidade' : '';

      messages.statusName =
        blur.statusName && !required(data.statusName) ? 'Informe o status' : '';

      messages.validity =
        blur.validity && !required(data.validity) ? 'Selecione a validade' : '';

      messages.branchCode =
        blur.branchCode && !required(data.branchCode)
          ? 'Selecione a filial'
          : '';

      return messages as any;
    }

    if (form === 'status.create') {
      const data = getValidity('forms.status.create');
      const blur = getValidity('blur.status.create');
      const messages: Record<
        keyof ValiditiesState['blur']['status']['create'],
        string
      > = {
        name: '',
        color: '',
      };
      messages.name = blur.name && !required(data.name) ? 'Informe o nome' : '';

      messages.color =
        blur.color && !required(data.color) ? 'Informe a cor' : '';

      return messages as any;
    }

    if (form === 'status.update') {
      const data = getValidity('forms.status.update');
      const blur = getValidity('blur.status.update');
      const messages: Record<
        keyof ValiditiesState['blur']['status']['update'],
        string
      > = {
        name: '',
        color: '',
      };
      messages.name = blur.name && !required(data.name) ? 'Informe o nome' : '';

      messages.color =
        blur.color && !required(data.color) ? 'Informe a cor' : '';

      return messages as any;
    }

    return {} as any;
  };

const validityGetters = (state: RootState) => ({
  getValidity: getValidity(state),
  getFormMessage: getFormMessage(state),
});
export default validityGetters;
